import Flash from './Flash'

export default {

  inputs: document.querySelectorAll('.js-input-file'),

  initInput: function (input) {
    input.addEventListener('change', (e) => {
      const maxSize = parseInt(input.getAttribute('data-file-size-max'))
      if (maxSize) {
        const size = input.files[0].size/1024/1024
        if (size > maxSize) {
          Flash.warning('File size not accepted')
          input.value = ''
        }
      }
    })
  },

  init: function () {
    this.inputs.forEach((input) => {
      this.initInput(input)
    })
  }
}


// WEBPACK FOOTER //
// app/javascript/scripts/components/InputFile.js